var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeezer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 25,
    viewBox: "0 0 127 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7307 16.29C29.7307 21.3827 32.8676 24.4307 37.5285 24.4307C39.8526 24.4307 41.8084 23.783 42.9006 22.0812V24.4307H47.1551V0.173706H42.7355V10.4861C41.7322 8.78431 39.878 8.02231 37.5539 8.02231C33.0073 8.00961 29.7307 11.1211 29.7307 16.29ZM42.8752 16.29C42.8752 19.1983 40.894 21.0144 38.5191 21.0144C36.0553 21.0144 34.163 19.1983 34.163 16.29C34.163 13.3309 36.068 11.4767 38.5191 11.4767C40.894 11.4767 42.8752 13.3563 42.8752 16.29Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9092 18.1696C60.4012 20.0492 59.1185 20.989 57.0992 20.989C54.7497 20.989 52.8193 19.5666 52.7685 17.052H63.9064C64.0461 16.4297 64.1096 15.7693 64.1096 15.0454C64.1096 10.5369 61.0362 7.99692 56.5023 7.99692C51.6636 7.99692 48.3362 11.4386 48.3362 16.1122C48.3362 21.3192 52.0065 24.4434 57.0865 24.4434C60.9219 24.4434 63.5254 22.8432 64.6684 19.6555L60.9092 18.1696ZM52.7685 14.1056C53.1876 12.2895 54.6989 11.2227 56.515 11.2227C58.4962 11.2227 59.8424 12.2895 59.8424 13.9659L59.817 14.1056H52.7685Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3049 18.1696C76.7969 20.0492 75.5142 20.989 73.4949 20.989C71.1454 20.989 69.215 19.5666 69.1642 17.052H80.3021C80.4418 16.4297 80.5053 15.7693 80.5053 15.0454C80.5053 10.5369 77.4319 7.99692 72.898 7.99692C68.0593 7.99692 64.7319 11.4386 64.7319 16.1122C64.7319 21.3192 68.4022 24.4434 73.4822 24.4434C77.3176 24.4434 79.9211 22.8432 81.0641 19.6555L77.3049 18.1696ZM69.1642 14.1056C69.5833 12.2895 71.0946 11.2227 72.9107 11.2227C74.8919 11.2227 76.2381 12.2895 76.2381 13.9659L76.2127 14.1056H69.1642Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1009 24.4561V20.4556H86.8172L95.8469 11.6672V8.00961H81.5594V11.8196H90.2843L81.28 20.6461V24.4561H96.1009Z",
    fill: "#ffffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.017 18.1696C108.509 20.0492 107.226 20.989 105.207 20.989C102.857 20.989 100.927 19.5666 100.876 17.052H112.014C112.154 16.4297 112.217 15.7693 112.217 15.0454C112.217 10.5369 109.144 7.99692 104.61 7.99692C99.7712 7.99692 96.4438 11.4386 96.4438 16.1122C96.4438 21.3192 100.114 24.4434 105.194 24.4434C109.03 24.4434 111.633 22.8432 112.776 19.6555L109.017 18.1696ZM100.876 14.1056C101.295 12.2895 102.807 11.2227 104.623 11.2227C106.604 11.2227 107.95 12.2895 107.95 13.9659L107.925 14.1056H100.876Z",
    fill: "#ffffff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1968 8.00961H19.7485V11.1973H25.1968V8.00961Z",
    fill: "#ffffff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1968 12.4292H19.7485V15.6169H25.1968V12.4292Z",
    fill: "#ffffff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1968 16.8488H19.7485V20.0365H25.1968V16.8488Z",
    fill: "#ffffff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4483 21.2684H0V24.4561H5.4483V21.2684Z",
    fill: "#ffffff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0269 21.2684H6.57861V24.4561H12.0269V21.2684Z",
    fill: "#ffffff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6182 21.2684H13.1699V24.4561H18.6182V21.2684Z",
    fill: "#ffffff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1968 21.2684H19.7485V24.4561H25.1968V21.2684Z",
    fill: "#ffffff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6182 16.8488H13.1699V20.0365H18.6182V16.8488Z",
    fill: "#ffffff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0269 16.8488H6.57861V20.0365H12.0269V16.8488Z",
    fill: "#ffffff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0269 12.4292H6.57861V15.6169H12.0269V12.4292Z",
    fill: "#ffffff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M122.695 13.6865C122.695 13.8516 122.695 14.1564 122.695 14.1564H127C127 14.1564 127 13.3436 127 12.8991C127 10.0797 125.235 8.035 122.276 8.035C120.371 8.035 119.024 8.9621 118.326 10.4988V8.035H113.881V24.4561H118.326V13.877C118.326 12.2006 119.228 11.2735 120.612 11.2735C121.882 11.2862 122.695 12.48 122.695 13.6865Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeezer);
export default __webpack_public_path__ + "static/media/Deezer.7812260198eae09b9b772a60ef6d967c.svg";
export { ForwardRef as ReactComponent };